import React from "react";
import { Link } from "react-router-dom";

import whyChooseUsData from "../../data/home-why-choose-us.json";

const WhyChooseUs = () => {
  return (
    <>
      <section className="promo-section ptb-100">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7 col-md-8">
              <div className="section-heading text-center mb-5">
                <h2>{whyChooseUsData.title}</h2>
                <p className="lead">{whyChooseUsData.description}</p>
              </div>
            </div>
          </div>
          <div className="row equal">
            {whyChooseUsData.sections.map((data) => (
              <div key={data.id} className="col-md-4 col-lg-4">
                <div className="single-promo single-promo-hover single-promo-1 rounded text-center white-bg p-5 h-100">
                  <div className="circle-icon mb-5">
                    <span className={`${data.icon} text-white`}></span>
                  </div>
                  <h5>{data.title}</h5>
                  <p>{data.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-4">
            <Link className="btn solid-btn" to={whyChooseUsData["button-link"]}>
              {whyChooseUsData.button}
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default WhyChooseUs;
